export type CommandDeckStatusPillVariant =
  | 'active'
  | 'ready'
  | 'preview'
  | 'soon'
  | 'locked'
  | 'current'
  | 'pending'
  | 'aligned'
  | 'beta'
  | 'planned'

interface Props {
  label: string
  variant: CommandDeckStatusPillVariant
  className?: string
}

export function CommandDeckStatusPill({ label, variant, className }: Props) {
  const classes = ['cd-status-pill', `cd-status-pill--${variant}`, className].filter(Boolean).join(' ')
  return <span className={classes}>{label}</span>
}
